/**
 * Compute the end date (ISO string) for a stay starting on `startDate`
 * lasting `nights` nights. Returns the last night's date.
 *
 * Example: startDate "2026-02-24", nights 3 → "2026-02-26"
 */
export function computeEndDate(startDate: string, nights: number): string {
  const d = new Date(`${startDate}T00:00:00`);
  d.setDate(d.getDate() + nights - 1);
  return d.toISOString().slice(0, 10);
}

/**
 * Format an ISO date string as a short display string, e.g. "Feb 24".
 */
export function formatShortDate(iso: string): string {
  if (!iso) return '';
  const d = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}
